import { CustomDataSource, Cartesian3, Color } from 'cesium';
import {transformGeometry} from '../feature-layer/createFeatureCollection';
import GradualLightRingMaterialProperty from './GradualLightRingMaterialProperty.js';
import transformRgb from '../_util/transformRgb';

export default class FenceLayer extends CustomDataSource {
    constructor(option) {
        const {
            data,
            key,
            labelField,
            template,
            height,
            color,
            speed,
            repeatNum,
            opacity,
            name,
            layerControl,
            show = true,
            map,
            legend
        } = option;

        super(option);
        super.show = show;
        // 图层标识
        this.key = key;

        // 图层名称
        this.name = name;

        // 标签字段
        this.labelField = labelField;

        // 模版内容
        this.template = template;

        this.data = data;

        // 颜色
        this.color = color || '#0080ff';

        // 高度
        this.height = height || 1000;

        // 速度
        this.speed = speed || 1;

        // 重复数量
        this.repeatNum = repeatNum || 3;

        // 透明度
        this.opacity = opacity || 1;

        this.legend = legend;

        // 地图
        this.map = map;

        this.layerControl = layerControl;
        if (data?.length) {
            this.loadData(data);
        }
    }
    // 重写父类的属性访问器
    get show() {
        return super.show;
    }

    set show(value) {
        this.setVisible(value);
    }

    // 获取地图
    getMap() {
        return this.map;
    }

    // 设置图层显示隐藏
    setVisible(visible) {
        super.show = visible; // 将属性传递给父类

        const map = this.getMap && this.getMap();
        if (map) {
            map.layers.emit('visible', this, visible);
        }
    }

    loadData(data) {
        this.entities.removeAll();

        let height = this.height;
        let color = this.color;
        let speed = this.speed;
        let repeatNum = this.repeatNum;
        let opacity = this.opacity;

        data.map((v, index) => {
            let positions = [];
            let { geometryInfo = {} } = v;
            let { coordinates } = transformGeometry(geometryInfo);
            if (coordinates && coordinates.length) {
                coordinates?.[0]?.map(c => {
                    positions.push(...c, c.height || height);
                });
            }

            const entity_fly = this.entities.add({
                wall: {
                    positions: Cartesian3.fromDegreesArrayHeights(positions),
                    material: new GradualLightRingMaterialProperty({
                        color: Color.fromCssColorString(transformRgb(v.color || color, v.opacity || opacity)),
                        speed: v.speed || speed,
                        repeatNum: v.repeatNum || repeatNum,
                    }),
                    outline: false,
                    zIndex: v.zIndex || index,
                },
            });

            entity_fly.type = this.modalType || this.key;
            entity_fly.key = this.key;
            entity_fly.properties = v.properties || {};
        });
    }

    // 根据条件获取图形数据
    getFeatureByFieldValue(field, value) {
        return this.getFeatures().find(v => String(v?.properties?.[field]?._value) === String(value));
    }

    // 获取当前图层的所有图形
    getFeatures() {
        return this.entities.values;
    }
}
